import { defineStore } from "pinia";
import { ref } from "vue";

export const useUserStore = defineStore("user", () => {
	let currentUser = ref<{
		id: string;
		email: string;
		firstname: string;
		lastname: string;
		color: string;
	} | null>(null);

	return {
		currentUser,
	};
});
